import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Carlos Mendoza',
      role: 'Director de Eventos Corporativos',
      company: 'Grupo Empresarial del Sureste',
      image: 'https://public.readdy.ai/ai/img_res/fd94f43ded8b65d1baef9af5c40f638a.jpg',
      text: 'Esfera Records transformó nuestro evento anual en una experiencia inolvidable. Su profesionalismo, atención al detalle y la calidad de sus artistas superaron todas nuestras expectativas. Sin duda, los mejores en el negocio.',
      rating: 5
    },
    {
      name: 'Ana Patricia Ruiz',
      role: 'Novia',
      company: 'Boda en Puebla',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20mexican%20bride%20woman%20smiling%20joyfully%20wearing%20elegant%20white%20wedding%20dress%20with%20professional%20makeup%20and%20hairstyle%20on%20clean%20simple%20white%20background%20studio%20portrait%20photography%20happy%20expression&width=400&height=400&seq=test-002&orientation=squarish',
      text: 'Mi boda fue perfecta gracias a Esfera Records. El grupo musical que contratamos fue espectacular, todos nuestros invitados quedaron encantados. El equipo de sonido fue impecable y la coordinación fue excelente. ¡Altamente recomendados!',
      rating: 5
    },
    {
      name: 'Roberto Sánchez',
      role: 'Organizador de Festivales',
      company: 'Festivales Culturales de Tlaxcala',
      image: 'https://readdy.ai/api/search-image?query=confident%20mexican%20event%20organizer%20man%20wearing%20casual%20business%20attire%20smiling%20professionally%20holding%20clipboard%20on%20clean%20simple%20white%20background%20studio%20portrait%20photography%20friendly%20approachable%20look&width=400&height=400&seq=test-003&orientation=squarish',
      text: 'Hemos trabajado con Esfera Records en múltiples ocasiones para nuestros festivales culturales. Su capacidad para manejar eventos grandes, la calidad de su equipo de sonido y la variedad de artistas disponibles los hace nuestro proveedor preferido.',
      rating: 5
    },
    {
      name: 'Gabriela Torres',
      role: 'Gerente de Marketing',
      company: 'Innovación Digital MX',
      image: 'https://readdy.ai/api/search-image?query=professional%20mexican%20businesswoman%20in%20elegant%20blazer%20smiling%20confidently%20corporate%20headshot%20on%20clean%20simple%20white%20background%20studio%20lighting%20modern%20professional%20portrait%20photography&width=400&height=400&seq=test-004&orientation=squarish',
      text: 'Para el lanzamiento de nuestro producto necesitábamos algo especial. Esfera Records nos proporcionó no solo excelente música en vivo, sino también una producción completa que impresionó a todos nuestros clientes e invitados. Servicio de primera clase.',
      rating: 5
    },
    {
      name: 'Miguel Ángel Flores',
      role: 'Artista Independiente',
      company: 'Grabación en Estudio',
      image: 'https://readdy.ai/api/search-image?query=young%20mexican%20male%20musician%20artist%20wearing%20casual%20trendy%20clothes%20with%20headphones%20around%20neck%20smiling%20confidently%20on%20clean%20simple%20white%20background%20studio%20portrait%20photography%20creative%20artistic%20vibe&width=400&height=400&seq=test-005&orientation=squarish',
      text: 'Grabé mi primer álbum en el estudio de Esfera Records y la experiencia fue increíble. Los ingenieros de sonido son muy profesionales y pacientes. El resultado final superó mis expectativas. El mejor estudio de la región sin duda.',
      rating: 5
    },
    {
      name: 'Laura Martínez',
      role: 'Coordinadora de Eventos',
      company: 'Hotel Grand Fiesta',
      image: 'https://readdy.ai/api/search-image?query=elegant%20mexican%20woman%20event%20coordinator%20wearing%20professional%20business%20attire%20smiling%20warmly%20holding%20tablet%20on%20clean%20simple%20white%20background%20studio%20portrait%20photography%20sophisticated%20professional%20look&width=400&height=400&seq=test-006&orientation=squarish',
      text: 'Como coordinadora de eventos del hotel, he trabajado con muchos proveedores, pero Esfera Records destaca por su confiabilidad y calidad. Siempre cumplen en tiempo y forma, y sus artistas son excepcionales. Son nuestros aliados de confianza.',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonios" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat',sans-serif] text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="font-['Poppins',sans-serif] text-base text-gray-600 max-w-2xl mx-auto">
            La satisfacción de nuestros clientes es nuestra mejor carta de presentación
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <div className="w-32 h-32 rounded-full overflow-hidden shadow-lg">
                  <img 
                    src={testimonials[activeIndex].image}
                    alt={testimonials[activeIndex].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              
              <div className="flex-1 text-center md:text-left">
                <div className="flex justify-center md:justify-start mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl w-6 h-6 flex items-center justify-center"></i>
                  ))}
                </div>
                
                <p className="font-['Poppins',sans-serif] text-base text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonials[activeIndex].text}"
                </p>
                
                <div>
                  <h4 className="font-['Montserrat',sans-serif] text-lg font-bold text-gray-900">
                    {testimonials[activeIndex].name}
                  </h4>
                  <p className="font-['Poppins',sans-serif] text-sm text-teal-600 font-medium">
                    {testimonials[activeIndex].role}
                  </p>
                  <p className="font-['Poppins',sans-serif] text-sm text-gray-500">
                    {testimonials[activeIndex].company}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <button 
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-teal-600 hover:text-white transition-all cursor-pointer group"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700 group-hover:text-white w-6 h-6 flex items-center justify-center"></i>
          </button>
          
          <button 
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-teal-600 hover:text-white transition-all cursor-pointer group"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-700 group-hover:text-white w-6 h-6 flex items-center justify-center"></i>
          </button>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  index === activeIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
